import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import sanitize from 'sanitize-html';
import Tooltip from '@src/components/Tooltip';
import { StyledFailureWarning } from './index.style';

// Shared by the list and the grid. The message carries <br/> and <i>, so it is
// sanitized before it becomes html — not worth writing out twice.
const FailureWarning = ({ placement }) => {
  const { t } = useTranslation();

  // Parsing html on every render of every failed row adds up.
  const message = useMemo(() => sanitize(t('extractionFailed')), [t]);

  return (
    <Tooltip
      placement={placement}
      arrow
      title={
        // eslint-disable-next-line react/no-danger
        <span dangerouslySetInnerHTML={{ __html: message }} />
      }
    >
      <StyledFailureWarning />
    </Tooltip>
  );
};

export default React.memo(FailureWarning);
